const ONLY_ONBOARDING = 'ONLY_ONBOARDING' as const;
const ONBOARDING_WITH_ADV = 'ONBOARDING_WITH_ADV' as const;
const AFTER_ONBOARDING_ADV = 'AFTER_ONBOARDING_ADV' as const;
const ONBOARDING_WITH_CONFIGURED = 'ONBOARDING_WITH_CONFIGURED' as const;
const AFTER_ONBOARDING_CONFIGURED = 'AFTER_ONBOARDING_CONFIGURED' as const;
const HIDDEN = 'HIDDEN' as const;
const ALERT_COMPACT = 'ALERT_COMPACT' as const;
const ALERT_EXPANDED = 'ALERT_EXPANDED' as const;

export const TOP_BAR_LAYOUT = {
    HIDDEN,
    ALERT_COMPACT,
    ALERT_EXPANDED,
    ONLY_ONBOARDING,
    ONBOARDING_WITH_ADV,
    AFTER_ONBOARDING_ADV,
    ONBOARDING_WITH_CONFIGURED,
    AFTER_ONBOARDING_CONFIGURED,
} as const;

export const TOP_BAR_CONTENT_TYPES = {
    CALL_ME_BANNER: 'CALL_ME_BANNER',
    CONFIGURABLE_COMMUNICATION: 'CONFIGURABLE_COMMUNICATION',
    COMPANY_NAME_MODERATION: 'COMPANY_NAME_MODERATION',
    STORE_BANNED: 'STORE_BANNED',
    HIDDEN: 'HIDDEN',
} as const;
